var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.$.existing_columns_view,
      style: _vm.showStub ? { padding: 0 } : "",
    },
    [
      _c("div", { class: _vm.$.existing_columns_view__body }, [
        _vm.showStub
          ? _c("div", { class: _vm.$.stub }, [
              _c(
                "div",
                { class: _vm.$.wrapper },
                [
                  _c("vgp-svg-image", { attrs: { name: _vm.stubPicture } }),
                  _vm._v(" "),
                  _c("div", { class: _vm.$.desc }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.locale("" + _vm.stubDesc)) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ])
          : _c("div", { class: _vm.$.wrapper }, [
              _c(
                "div",
                {
                  class: [_vm.$.slot, _vm.$.slot__search],
                  style: _vm.emprtySearchResult ? { margin: 0 } : "",
                },
                [
                  _c("vgp-label-slot", {
                    attrs: {
                      label: _vm.locale(
                        "columns_bar_search_exist_column_label"
                      ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c("vgp-input", {
                              attrs: {
                                value: _vm.searchValue,
                                small: true,
                                placeholder: _vm.locale(
                                  "custom_column_item_placeholder"
                                ),
                                "icons-left": [
                                  { name: "search", handler: null },
                                ],
                                "icons-right": _vm.iconsRight,
                              },
                              on: { onChange: _vm.onColumnNameChange },
                              model: {
                                value: _vm.searchValue,
                                callback: function ($$v) {
                                  _vm.searchValue = $$v
                                },
                                expression: "searchValue",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.emprtySearchResult
                ? _c("div", { class: [_vm.$.stub, _vm.$.search] }, [
                    _c(
                      "div",
                      { class: _vm.$.wrapper },
                      [
                        _c("vgp-svg-image", {
                          attrs: { name: "columns-bar-empty-search" },
                        }),
                        _vm._v(" "),
                        _c("div", { class: _vm.$.desc }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.locale(
                                  "columns-bar-stub-desc-no-search-result"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ])
                : _c(
                    "div",
                    {
                      class: [
                        _vm.$.slot__list,
                        !_vm.showManageButton && !_vm.showCreateButton
                          ? _vm.$.height_without_footer
                          : "",
                        "gantt_scroll",
                      ],
                    },
                    _vm._l(_vm.existingColumns, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          class: _vm.$.item,
                          on: {
                            click: function ($event) {
                              return _vm.reuseClick(item)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { class: _vm.$.icon },
                            [
                              _c("svg-sprite", {
                                attrs: {
                                  name: item.icon.name,
                                  type: item.icon.type,
                                  size: item.icon.size,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { class: _vm.$.info }, [
                            _c("div", { class: _vm.$.name }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.name) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { class: _vm.$.type }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.typeName) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { class: _vm.$.button },
                            [
                              _c("vgp-button", {
                                attrs: {
                                  id: "gp_autotest_columns_bar_use_global_column",
                                  label: _vm.locale("common_reuse"),
                                  type: "text",
                                  "x-small": true,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
            ]),
      ]),
      _vm._v(" "),
      _vm.showManageButton || _vm.showCreateButton
        ? _c(
            "div",
            { class: _vm.$.existing_columns_view__footer },
            [
              _vm.showCreateButton
                ? _c("vgp-button", {
                    attrs: {
                      id: "gp_autotest_columns_bar_create_new",
                      label: _vm.locale("columns_bar_create_new"),
                      type: "primary-border",
                      icon: { name: "plus-1", type: "bold", size: 24 },
                      "icon-side": "left",
                    },
                    on: { onClick: _vm.moveToCreationColumn },
                  })
                : _vm.showManageButton
                ? _c("vgp-button", {
                    class: _vm.$.manage_button,
                    attrs: {
                      id: "gp_autotest_columns_bar_redirect_to_account_settings",
                      label: _vm.locale("columns_bar_manage_global_columns"),
                      type: "text",
                      icon: { name: "arrow-right", type: "bold", size: 20 },
                      "icon-side": "right",
                    },
                    on: { onClick: _vm.redirectToSettingsClick },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }